import { colors } from '../../Colors/colors'

export const portalsNavbarTheme = {
   light: {
      header: {},

      body: {},

      footer: {}
   },

   dark: {}
}
